import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";
import { SyntheticEvent } from "react";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: any) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>{t("Contact")}</Language>
              <Large
                to='#'
                onClick={(e: SyntheticEvent) => {
                  window.location.href = 'mailto:l.qqbadze@gmail.com';
                  e.preventDefault();
                }}
              >
                {t("Tell us everything")}
              </Large>
              <Para>
                {t(`Do you have any question? Feel free to reach out.`)}
              </Para>
              <a href="https://t.me/eurity" target="_blank" rel="noreferrer" >
                <Chat>{t(`Let's Chat`)}</Chat>
              </a>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Policy")}</Title>
              <Large to="/" left="true">
                {t("Application Security")}
              </Large>
              <Large left="true" to="/">
                {t("Software Principles")}
              </Large>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
            <Title>{t("Codebase")}</Title>
              <Large to="/" left="true">
                {t("Frontend")}
              </Large>
              <Large
                left="true"
                to={{ pathname: "https://github.com/tandelov/euro" }} 
                target="_blank"
              >
                {t("Blockchain")}
              </Large>
            </Col>
          </Row>
          
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon width='100%' height='100%' src='logo.svg'/>
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              <SocialLink
                href="https://github.com/tandelov/euro"
                src="github.svg"
              />
              <SocialLink
                href="https://twitter.com/eurity_money"
                src="twitter.svg"
              />
              <SocialLink
                href="https://medium.com/@eurity"
                src="medium.svg"
              />
              <SocialLink
                href="https://t.me/eurity"
                src="telegram.svg"
              />
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);